import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import './styles/main';

class CdnUsage extends React.Component {
    state = {
      ajaxCalls: [],
      loading: true,
      tracers: {}
    };

    componentDidMount() {
      this.addTabListener();
    }

    componentWillUnmount() {
      this.removeTabListener();
      this.abortAjaxCalls();
    }

    addTabListener = () => {
      window.addEventListener(
        `usageAssetTabHover${this.props.assetKey}`,
        this.requestCDNTracers,
        false
      );
    }

    removeTabListener = () => {
      window.removeEventListener(
        `usageAssetTabHover${this.props.assetKey}`,
        this.requestCDNTracers,
        false
      );
    }

    requestCDNTracers = () => {
      if (this.state.loading) {
        const request = $.ajax({
          context: this,
          type: "GET",
          url: `/api/v4/assets/${
            this.props.assetKey
          }/cdn_tracers`,
          timeout: 10000,
          beforeSend: (xhr) => {
            xhr.setRequestHeader("Authorization", `Bearer ${BF_Token}`);
          },
          success: (response) => {
            const sortedTracers = {};
            response.data.forEach((tracer, i) => {
              const referrer = tracer.attributes.referrer;
              const referrerBase = (
                referrer.indexOf('/') > -1 ? referrer.slice(0, referrer.indexOf('/')) : referrer
              );

              if (!sortedTracers[referrerBase]) {
                sortedTracers[referrerBase] = [];
              }

              sortedTracers[referrerBase].push(tracer);
              if (i === response.data.length - 1) {
                this.setState({ tracers: sortedTracers });
              }
            });
            this.setState({ loading: false });
          },
          error: () => {
            // TODO Create error state
            this.setState({ loading: false });
          }
        });
        this.updateAjaxCalls(request);
      }
    }

    updateAjaxCalls(xhr) {
      this.setState((prevState) => {
        const updatedAjaxCalls = [...prevState.ajaxCalls];
        updatedAjaxCalls.push(xhr);

        return { ajaxCalls: updatedAjaxCalls };
      });
    }

    abortAjaxCalls() {
      this.state.ajaxCalls.forEach((ajaxCall) => {
        if (ajaxCall.readyState !== 4) {
          ajaxCall.abort();
        }
      });
    }

    renderCDNLinks() {
      return Object.keys(this.state.tracers).map((tracer) => (
        <li key={tracer} className="grid-row">
          <div className="sub-row domain">
            <a
              href={tracer}
              target="_blank"
              rel="noopener noreferrer"
              className="domain-url"
            >
              {tracer}
            </a>
          </div>
          <h4 className="sub-row">{t('Pages')}</h4>
          {this.state.tracers[tracer].map((item) => {
            if (item.attributes.referrer === tracer) { return null; }
            const formattedDate = moment(item.attributes.visited_at).format('M/DD/YYYY');
            return (
              <div key={item.id} className="cdn-item sub-row">
                <div className="link">
                  <a
                    href={`//${item.attributes.referrer}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.attributes.referrer.split(tracer)[1]}
                  </a>
                </div>
                <span className="last-visited-date">{formattedDate}</span>
                <div className="active-status">
                  <img
                    src="https://cdn.brandfolder.io/4OQZ5PW1/as/pgcmrk-atsn5k-8ss6t6/active-status.svg"
                    alt="green active status"
                  />
                  <span>{t('Active')}</span>
                </div>
              </div>
            );
          })}
        </li>
      ));
    }

    render() {
      const { loading, tracers } = this.state;

      if (loading) {
        return (
          <div className="flex-two-thirds no-similar-details loader-container">
            <video
              className="brandfolder-loader"
              width="90"
              height="90"
              poster="https://cdn.brandfolder.io/4OQZ5PW1/as/pxmju5-qfr48-21nt37/generic-loader.gif"
            />
          </div>
        );
      }

      return (
        <div className="cdn-usage-wrap">
          <div className="cdn-title">
            <p>{t('CDN Links')}</p>
            {Object.keys(tracers).length > 0 ? <p><span className="indicator-circle" />{t('You have active CDN links')}</p> : '' }
          </div>
          {Object.keys(tracers).length > 0 ? (
            <ul className="usage-grid">
              <li className="grid-row grid-header">
                <h4 className="link">{t('Location')}</h4>
                <h4>{t('Last Visited')}</h4>
                <h4>{t('Status')}</h4>
              </li>
              {this.renderCDNLinks()}
            </ul>
          ) : (
            <div className="no-links-container">
              <img
                className="empty-box"
                src="https://cdn.brandfolder.io/4OQZ5PW1/as/pgaxfs-dfey68-fnjpxe/empty.svg"
                alt="person digging in empty box"
              />
              <h3>{t("You don't have any CDN Links yet!")}</h3>
              <p>
                {t("CDN (Content Delivery Network) Links allow you to embed assets on external websites, while housing the single source of truth version.")}
              </p>
              <p className="list-title">{t("With CDN Links, you can:")}</p>
              <ul>
                <li>
                  <span className="bff-confirmation" />
                  {t('Edit in Brandfolder and see the changes reflected on external sites')}
                </li>
                <li>
                  <span className="bff-confirmation" />
                  {t('Track asset usage outside of the app')}
                </li>
              </ul>
              <br />
              {BFG.context.hasFeature('embed_asset')
                ? <p>{t(' Visit the Embed tab to create and customize your CDN links and learn more about how they work. Embedding is only available for published and approved assets.')}</p>
                : <p>{t(' If you have the embed assets feature turned on, visit the Embed tab to create and customize your CDN links and learn more about how they work. Embedding is only available for published and approved assets.')}</p>
              }
            </div>
          )}
        </div>
      );
    }
}

CdnUsage.propTypes = {
  assetKey: PropTypes.string.isRequired
};

export default CdnUsage;
